import {otsBaseApi} from "../../ots-api";
import {ContainerCluster} from "../../../model/container-cluster";
import {removeUndefined} from "../../../util/util";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: ["ContainerClusters"]});

const containerClusterApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllContainerClusters: builder.query<ContainerCluster[], string | undefined>({
      query: (regionId) => ({
        url: `/container-clusters/all`,
        method: "GET",
        params: removeUndefined({
          regionId: regionId
        })
      }),
      keepUnusedDataFor: 300,
      providesTags: (result) => {
        if (result) {
          return [
            ...result.map(({id}) => ({type: "ContainerClusters", id} as const)),
            {type: "ContainerClusters", id: "LIST"}
          ];
        } else {
          return [{type: "ContainerClusters", id: "LIST"}];
        }
      }
    }),
    getContainerCluster: builder.query<ContainerCluster, string>({
      query: (id) => ({
        url: `/container-clusters/${id}`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{type: "ContainerClusters", id}]
    }),
    createContainerCluster: builder.mutation<ContainerCluster, Partial<ContainerCluster>>({
      query: (mapping) => ({
        url: "/container-clusters",
        method: "POST",
        body: mapping
      }),
      invalidatesTags: [{type: "ContainerClusters", id: "LIST"}]
    }),
    updateContainerCluster: builder.mutation<ContainerCluster, Partial<ContainerCluster>>({
      query: (mapping) => ({
        url: "/container-clusters",
        method: "PUT",
        body: mapping,
      }),
      invalidatesTags: (result, error, {id}) => [{type: "ContainerClusters", id}]
    }),
    deleteContainerCluster: builder.mutation<void, Partial<ContainerCluster>>({
      query: (mapping) => ({
        url: "/container-clusters",
        method: "DELETE",
        body: mapping
      }),
      invalidatesTags: (result, error, {id}) => [{type: "ContainerClusters", id}]
    }),
  })
});

export const {
  useGetAllContainerClustersQuery,
  useGetContainerClusterQuery,
  useCreateContainerClusterMutation,
  useUpdateContainerClusterMutation,
  useDeleteContainerClusterMutation,
} = containerClusterApi;
